import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';

export const FormationIcon = () => <SchoolOutlinedIcon />;
